import { render, staticRenderFns } from "./FirstTimeTips.vue?vue&type=template&id=26dcaf18"
import script from "./FirstTimeTips.vue?vue&type=script&lang=js"
export * from "./FirstTimeTips.vue?vue&type=script&lang=js"
import style0 from "./FirstTimeTips.vue?vue&type=style&index=0&id=26dcaf18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports